import { BASE_URL,COMPETENCY_MAPPING  } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ICompetencyMapping } from "models/competencyMapping";

export async function getCompetencyMapping(params: string = "") {
  try {
    const response = await axios.get(BASE_URL + COMPETENCY_MAPPING + params);
    return response?.data || [];
  } catch (error) {
    console.error("Error fetching competency mapping:", error);
    throw error;
  }
}

export async function saveCompetencyMapping(data: ICompetencyMapping[]) {
  const response = await axios.post(BASE_URL + COMPETENCY_MAPPING, data);
  return response.data;
}

// export async function addEmployee(data: FormData) {
//   const response = await axios.post(BASE_URL + COMPETENCY_MAPPING, data);
//   return response.data;
// }
// export async function editEmployee(data: FormData, id: string) {
//   const response = await axios.patch(BASE_URL + COMPETENCY_MAPPING + "/" + id, data);
//   return response.data;
// }

// export async function deleteEmployee(id: string) {
//   const response = await axios.delete(BASE_URL + COMPETENCY_MAPPING + "/" + id);
//   return response.data;
// }

export const EmployeeCells: HeadCell[] = [
  {
    id: "ProfilePicture",
    numeric: false,
    disablePadding: false,
    label: "T_Logo",
  },
  {
    id: "FirstName",
    numeric: false,
    disablePadding: false,
    label: "T_first_name",
  },
  {
    id: "MiddleName",
    numeric: false,
    disablePadding: false,
    label: "T_middle_name",
  },
  {
    id: "LastName",
    numeric: false,
    disablePadding: false,
    label: "T_last_name",
  },
  {
    id: "Email",
    numeric: false,
    disablePadding: false,
    label: "T_email",
  },
  {
    id: "Job",
    numeric: false,
    disablePadding: false,
    label: "T_job",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
